<template>
    <div class="fullHeight" v-if="golf_course_info.length > 1">
        <MypageSideMenu :memberDropClose="true" v-if="show"/>
        <div class="mypage_mainwindow">
            <div class="pageTitles">ゴルフ場一覧</div>
            <div class="golfList">
                <div class="cardwindow mb-3 mr-4 golfCard" v-for="info in golf_course_info" :key="info.id">
                    <div class="col-md-12">
                        <img :src="info.golf_course_img_path" style="
                            width: 100%;
                            height: 150px;
                            object-fit: cover;
                            margin: 0 0 20px 0;
                        ">
                        <div class="h4 mb-2">
                            <a :href="info.url" target="_blank" class="font-weight-bold">
                                {{ info.golf_name }}
                            </a>
                        </div>
                        <div class="mb-3">
                            <div>
                                <div class="py-2">{{ info.prefecture_name }}{{ info.municipality_name }}{{ info.local_name }}{{ info.building_name }}</div>
                                <div class="pb-2 d-md-flex">
                                    <div class="py-2 mr-4">Tel：{{ info.telephone }}</div>
                                    <div class="py-2" v-if="info.email">Email：{{ info.email }}</div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center align-items-center">
                                <router-link class="bluebackbutton searchButton" :to="{name:'reservepage',query:{gc:info.golf_code}}">
                                    プラン検索
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MypageMenuFooter v-if="show"/>
    </div>
</template>

<script>
import { GET_GOLFCOURSE } from "../../constants/golf_course";
import MypageSideMenu from '../mypage/MypageSideMenu.vue';
import MypageMenuFooter from '../mypage/MypageMenuFooter';

export default {
    props: {
        show: {
            type: [Boolean, Number, String],
            require: false,
            default: false
        }
    },
    components: {
        MypageSideMenu,
        MypageMenuFooter
    },
    data () {
        return {
            // モック用
            golf_course_info: [],
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function () {
            document.body.classList.remove('fix-body');
        /** ----------------------------------------------
         * ゴルフ場情報取得
         * ---------------------------------------------- */
            this.$store.commit("loading/setIsLoading", true);
            await this.$apollo.query({
                query: GET_GOLFCOURSE,
                variables: {
                    golf_group_code: process.env.MIX_GROUP_CODE,
                }
            }).then(res => {
                this.golf_course_info = res.data.getGolfCourse;
                // ゴルフ場が一つだけの時は、予約検索画面へ遷移
                if(this.golf_course_info.length === 1) {
                    this.$router.push('/reserve?gc=' + this.golf_course_info[0].golf_code);
                } else {
                    this.$store.commit("loading/setIsLoading", false);
                }
            })
            .catch(error => {
                this.error = error;
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        OnMypage: function () {
            this.$router.push('/mypage');
        },
    }
}

</script>

<style scoped>
.searchButton {
    width: 80%;
    text-align: center;
    cursor: pointer;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
}
.golfList {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.golfCard {
    width: calc(50% - 1.5rem);
}
.mypageframebutton {
    text-align: center;
    padding-top: 5px;
}
@media screen and (max-width: 896px) {
    .golfList {
        display: block;
    }
    .golfCard {
        width: 100%;
    }
}
@media screen and (max-width: 767px) {
    .searchButton {
        width: 100%;
    }
}
</style>
